import { render, staticRenderFns } from "./changeManage.vue?vue&type=template&id=cc145bf8&scoped=true&"
import script from "./changeManage.vue?vue&type=script&lang=js&"
export * from "./changeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc145bf8",
  null
  
)

export default component.exports